import { LOCALES } from 'i18n/locales';

export const notificationIntl = {
    [LOCALES.ENGLISH]: {
        'Notification.notification': 'Notification',
        'Notification.DefaultTitle': 'Important'
    },
    [LOCALES.WELSH]: {
        'Notification.notification': 'Hysbysiad',
        'Notification.DefaultTitle': 'Pwysig'
    }
};
